import "@chatscope/chat-ui-kit-styles/dist/default/styles.min.css";
import {
    MainContainer,
    ChatContainer,
    ConversationHeader,
    MessageList,
    Message,
    MessageSeparator,
    MessageInput,
    InputToolbox,
    Avatar,
} from "@chatscope/chat-ui-kit-react";
import {
    MAP_AVATAR_DEFAULT,
    MAP_EMOJI,
    SENDER_TYPE,
    TRACKING_TYPE,
} from "src/constant";
import tracking from "src/hooks/useTracking";
import "./styles.css";
import { useContext, useState } from "react";
import { WelcomeMsg } from "../WelcomeMsg";
import Linkify from 'react-linkify';
import { RelevantDocs } from "../RelevantDocs";
import { SubMenu } from "../SubMenu";
import { SettingContext } from "src/context/settings";

export const Widget = ({
    messages = [],
    onSend,
    isLoading = false,
    setMessages,
    sessionId,
}) => {
    const [isFirstStep, setIsFirstStep] = useState(true);
    const [text, setText] = useState('');
    const { settings } = useContext(SettingContext);

    const handleChooseStatus = (status, msgId) => {
        let lstMsg = messages.map((item) => {
            if (item.id === msgId) {
                item.ratings = [...MAP_EMOJI].map((i) => ({
                    ...i,
                    selected: i.type === status ? true : false,
                }));
                return item;
            } else return item;
        });
        setMessages(lstMsg);
        tracking(TRACKING_TYPE.RATING, { rate: status, mgsId: msgId, sessionId });
    };

    console.log(settings);
    console.log(messages);

    return (
        <MainContainer>
            {isFirstStep && settings.showWelcomeMsg ?
                <WelcomeMsg setIsFirstStep={setIsFirstStep} onSend={onSend} /> :
                <>
                    <ChatContainer>
                        <ConversationHeader>
                            <ConversationHeader.Content
                                userName={settings.header}
                                info=""
                            >
                            </ConversationHeader.Content>
                        </ConversationHeader>
                        <MessageList
                            className="message-list-custom"
                        >
                            {messages?.map((message, idx) => (
                                    <Message
                                        key={"msg-" + message.id}
                                        model={message}
                                        avatarPosition="tl"
                                    >
                                        <Avatar src={MAP_AVATAR_DEFAULT[message.sender]} size="md" />
                                        <Message.CustomContent>
                                            <Linkify componentDecorator={(decoratedHref, decoratedText, key) => <a target="blank" rel="noopener" href={decoratedHref} key={key}>
                                                {decoratedText}
                                            </a>}>
                                                {message.message}
                                            </Linkify>
                                            {/* {message.direction == "incoming" && <AudioPlayer text={message.message}/>} */}
                                        </Message.CustomContent>

                                        <Message.Footer>
                                        {message.relevantDocs && message.message.length > 20 && <RelevantDocs relevantDocs={message.relevantDocs} title={"Tài liệu liên quan"} kind={1} key={"rd-" + message.id} />}
                                        </Message.Footer>
                                    </Message>
                                    
                                    
                                    
                            ))}
                            {isLoading && (
                                <Message key={"msg-loading"}
                                    className="msg_placeholder"
                                    model={{
                                        message: "Đang chuẩn bị câu trả lời...",
                                        sentTime: "just now",
                                    }}
                                    avatarPosition="tl"
                                >
                                    <Avatar src={MAP_AVATAR_DEFAULT[SENDER_TYPE.REMOTE]} size="md" />
                                </Message>
                            )}
                        </MessageList>
                        <MessageInput
                            disabled={isLoading}
                            placeholder="Nhập nội dung cần hỗ trợ"
                            attachButton={false}
                            onSend={(message) => {
                                onSend(message);
                                setText('');
                            }}
                            autoFocus={true}
                            value={text}
                            onChange={(a, b) => setText(b)}
                        />
                        <InputToolbox>
                            <SubMenu />
                        </InputToolbox>
                    </ChatContainer>
                </>
            }
        </MainContainer>
    );
};
